var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"header-cell-style":{
      background: '#99DCFF',
      color: '#FFFFFF',
      height: '84px',
      'font-size': '26px',
      'line-height': '35px',
    },"row-style":{
      background: '#F6F6F6',
      color: '#333333',
      fontSize: '18px',
      height: '60px',
    }}},[_c('el-table-column',{attrs:{"label":"训练日期","prop":"date","align":"center"}}),_c('el-table-column',{attrs:{"label":"训练项目","prop":"content","align":"center"}}),_c('el-table-column',{attrs:{"label":"训练时长","prop":"duration","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm.minAndSecond(scope.row.duration))+"\n      ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }